export default __webpack_public_path__ + "d786cf9b771bd96f3c8eeac3a0ae5891.svg";